export default {
  FETCH_COMMUNITY_POSTS: 'FETCH_COMMUNITY_POSTS',
  FETCH_COMMUNITY_POSTS_SUCCESS: 'FETCH_COMMUNITY_POSTS_SUCCESS',
  FETCH_COMMUNITY_POSTS_FAILURE: 'FETCH_COMMUNITY_POSTS_FAILURE',

  FETCH_COMMUNITY_FEATURED_POSTS: 'FETCH_COMMUNITY_FEATURED_POSTS',
  FETCH_COMMUNITY_FEATURED_POSTS_SUCCESS: 'FETCH_COMMUNITY_FEATURED_POSTS_SUCCESS',
  FETCH_COMMUNITY_FEATURED_POSTS_FAILURE: 'FETCH_COMMUNITY_FEATURED_POSTS_FAILURE',

  DISMISS_COMMUNITY_FEATURED_POST: 'DISMISS_COMMUNITY_FEATURED_POST',
  DISMISS_COMMUNITY_FEATURED_POST_SUCCESS: 'DISMISS_COMMUNITY_FEATURED_POST_SUCCESS',
  DISMISS_COMMUNITY_FEATURED_POST_FAILURE: 'DISMISS_COMMUNITY_FEATURED_POST_FAILURE',

  FETCH_COMMUNITY_WIDGETS: 'FETCH_COMMUNITY_WIDGETS',
  FETCH_COMMUNITY_WIDGETS_SUCCESS: 'FETCH_COMMUNITY_WIDGETS_SUCCESS',
  FETCH_COMMUNITY_WIDGETS_FAILURE: 'FETCH_COMMUNITY_WIDGETS_FAILURE',
};
